import { c as _c } from "react/compiler-runtime";
// Сердце «Избранное на фото» из макета (компонент Figma с тремя состояниями)
// и залитое сердце для активного состояния вне фото.
import { type IconProps, Svg } from "./icon";
const PHOTO_HEART = "M19.4023 5.8125C22.586 5.8125 25.125 8.46644 25.125 11.7012C25.1249 14.8337 23.5225 17.4311 20.9834 19.8164C19.7947 20.9336 18.3964 21.9981 17.3057 22.7773C16.7584 23.1683 16.2843 23.4908 15.9463 23.7158C15.7772 23.8284 15.6413 23.9161 15.5479 23.9766C15.5014 24.0066 15.4653 24.03 15.4404 24.0459C15.428 24.0538 15.4177 24.0603 15.4111 24.0645C15.4081 24.0664 15.406 24.0682 15.4043 24.0693L15.4014 24.0713H15.4004C15.1877 24.2057 14.9244 24.2235 14.6982 24.124L14.6035 24.0742C14.603 24.0739 14.6015 24.0728 14.6006 24.0723C14.5987 24.0711 14.5961 24.0695 14.5928 24.0674C14.586 24.0631 14.5762 24.0568 14.5635 24.0488C14.5379 24.0327 14.5001 24.0091 14.4521 23.9785C14.3559 23.9171 14.2165 23.8269 14.043 23.7129C13.6962 23.485 13.2111 23.1593 12.6562 22.7656C11.552 21.982 10.1488 20.9141 9.00781 19.8076C6.75153 17.6196 4.87509 14.8376 4.875 11.7012C4.875 8.4757 7.41322 5.8125 10.5977 5.8125C12.3806 5.81255 13.9565 6.65205 15 7.94922C16.0435 6.65205 17.6194 5.81255 19.4023 5.8125Z";
const ACTIVE_HEART = "M20.6963 6.25C24.0629 6.25016 26.75 9.05725 26.75 12.4814C26.7499 15.5958 25.2575 18.2146 22.8438 20.6221L22.3486 21.1006C21.0829 22.2902 19.5935 23.4241 18.4307 24.2549C17.8473 24.6716 17.3417 25.0151 16.9814 25.2549C16.8014 25.3747 16.6571 25.4688 16.5576 25.5332C16.5079 25.5654 16.4688 25.5905 16.4424 25.6074C16.4292 25.6158 16.4191 25.6225 16.4121 25.627C16.4088 25.6291 16.4062 25.6307 16.4043 25.6318C16.4033 25.6324 16.4019 25.6325 16.4014 25.6328V25.6338H16.4004C16.1877 25.7682 15.9244 25.786 15.6982 25.6865L15.6035 25.6367C15.603 25.6364 15.6015 25.6354 15.6006 25.6348C15.5986 25.6335 15.5954 25.6322 15.5918 25.6299C15.5845 25.6253 15.5742 25.618 15.5605 25.6094C15.5332 25.5922 15.4935 25.5668 15.4424 25.5342C15.3399 25.4688 15.1916 25.3734 15.0068 25.252C14.6373 25.0091 14.1206 24.6618 13.5293 24.2422C12.3522 23.4069 10.857 22.2705 9.64258 21.0928C7.2396 18.7625 5.25018 15.8068 5.25 12.4814C5.25 9.06707 7.93629 6.25016 11.3037 6.25C13.2109 6.25 14.8962 7.15709 16 8.55664C17.1038 7.15709 18.7891 6.25 20.6963 6.25Z";

/**
 * Сердце избранного. Figma: «Избранное на фото».
 * - `variant="photo"` (по умолчанию, 32): на фото карточки — белая заливка 50 % и чёрная обводка 50 %.
 * - `variant="page"` (30): на странице (список магазинов, карточка) — белая заливка 50 % и обводка #333.
 * - `active`: залитое сердце #FA5C2E (оба варианта).
 * Рамки макета: photo 32×32, page 30×30; рисунок сердца одинаковый.
 */
export function FavoriteHeartIcon({
  active = false,
  variant = "photo",
  size = variant === "photo" ? 32 : 30,
  strokeWidth = 1.5,
  ...props
}: IconProps & {
  active?: boolean;
  variant?: "photo" | "page";
}) {
  // Рисунок сделан в рамке 30; на фото рамка 32 — сдвигаем на 1 px, чтобы центр совпал.
  const viewBox = variant === "photo" ? "-1 -1 32 32" : "0 0 30 30";
  if (active) {
    return <Svg size={size} viewBox="0 0 32 32" {...props}>
				<path d={ACTIVE_HEART} fill="#FA5C2E" stroke="#FA5C2E" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
			</Svg>;
  }
  return <Svg size={size} viewBox={viewBox} {...props}>
			<path d={PHOTO_HEART} fill="white" fillOpacity={0.5} stroke={variant === "photo" ? "black" : "#333333"} strokeOpacity={variant === "photo" ? 0.5 : 1} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
		</Svg>;
}

/**
 * Сердце залитое (активное избранное) цветом currentColor. Figma: «Избранное на фото / active».
 * Рамка подогнана под HeartIcon (24): контур и заливка взаимозаменяемы без сдвига.
 */
export function HeartFilledIcon(t0) {
  const $ = _c(10);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  const strokeWidth = t2 === undefined ? 1.5 : t2;
  let t3;
  if ($[4] !== strokeWidth) {
    t3 = <path d={ACTIVE_HEART} fill="currentColor" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />;
    $[4] = strokeWidth;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== size || $[8] !== t3) {
    t4 = <Svg size={size} viewBox="2.25 2.13 26.97 26.97" {...props}>{t3}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}